import { render, staticRenderFns } from "./ValueSelection.vue?vue&type=template&id=4515acf8&"
import script from "./ValueSelection.vue?vue&type=script&lang=js&"
export * from "./ValueSelection.vue?vue&type=script&lang=js&"
import style0 from "./ValueSelection.vue?vue&type=style&index=0&id=4515acf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports